import { BaseText } from '@adornis/buildify/db/extensions/text/BaseText.js';

type TextJSON = { type: string; content: { type: string; content: any[] }[] };

export const mergeBaseText = (first: BaseText, second: BaseText) => {
  const firstJSON = JSON.parse(first.text ?? '') as TextJSON;
  const secondJSON = JSON.parse(second.text ?? '') as TextJSON;
  const lastParagraphOfFirstText = firstJSON.content.at(firstJSON.content.length - 1);
  const firstParagraphOfSecondText = secondJSON.content.at(0);
  lastParagraphOfFirstText!.content.push(...[{ type: 'text', text: ' ' }, ...firstParagraphOfSecondText!.content]);
  firstJSON.content.push(...secondJSON.content.slice(1, secondJSON.content.length));
  return new BaseText({ text: JSON.stringify(firstJSON) });
};
